import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import {
  TRACKING_WEBHOOK_URL,
  TOTAL_TRACKED_STEPS,
  type TrackedStep,
} from "@/config/tracking";

const SESSION_KEY = "sv_tracking_session_id";

export function getOrCreateSessionId(): string {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id =
        typeof crypto !== "undefined" && "randomUUID" in crypto
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
  }
}

/**
 * Fires a `page_view` event to the n8n webhook on mount.
 * Safe in React StrictMode (deduped via ref).
 */
export function usePageViewTracking(stepInfo: TrackedStep) {
  const [searchParams] = useSearchParams();
  const sentRef = useRef(false);

  useEffect(() => {
    if (sentRef.current) return;
    sentRef.current = true;

    const groupId = searchParams.get("groupId");
    const Id = searchParams.get("Id") || searchParams.get("id");

    const payload = {
      event: "page_view",
      step: stepInfo.step,
      stepLabel: stepInfo.stepLabel,
      stepIndex: stepInfo.stepIndex,
      totalSteps: TOTAL_TRACKED_STEPS,
      groupId: groupId || null,
      Id: Id || null,
      sessionId: getOrCreateSessionId(),
      url: typeof window !== "undefined" ? window.location.href : "",
      referrer: typeof document !== "undefined" ? document.referrer : "",
      timestamp: new Date().toISOString(),
    };

    try {
      fetch(TRACKING_WEBHOOK_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch((err) => {
        console.warn("[page_view] webhook failed:", err);
      });
    } catch (err) {
      console.warn("[page_view] webhook threw:", err);
    }
  }, [searchParams, stepInfo.step, stepInfo.stepIndex, stepInfo.stepLabel]);
}
